@if (bannerType && bannerConfig) {
  <div class="w-full border-b" [style.background-color]="bannerConfig.bgColor" [style.border-color]="bannerConfig.borderColor">
    <div class="flex items-center justify-between w-full mx-auto container-lg px-4 py-2.5">
      <div class="flex items-center gap-3 flex-1 min-w-0">
        @if (bannerType === 'kyb-verification') {
          <span class="flex-shrink-0 text-xs font-semibold bg-yellow-400 text-yellow-900 px-2 py-0.5 rounded">KYB Required</span>
          <div class="flex flex-col min-w-0">
            <p class="text-sm font-semibold text-white m-0 leading-snug">Verify your business to start using Handshake</p>
            <p class="text-xs text-white/70 m-0 leading-snug hidden sm:block">Projects, clients, and payouts are locked until your business identity is confirmed.</p>
          </div>
        } @else if (bannerType === 'kyb-in-review') {
          <span class="flex-shrink-0 text-xs font-semibold bg-blue-300 text-blue-900 px-2 py-0.5 rounded">KYB In Review</span>
          <div class="flex flex-col min-w-0">
            <p class="text-sm font-semibold text-white m-0 leading-snug">Your KYB submission is under review</p>
            <p class="text-xs text-white/70 m-0 leading-snug hidden sm:block">We'll notify you once verification is complete — usually within 24 hours.</p>
          </div>
        } @else {
          <span nz-icon [nzType]="bannerConfig.icon" class="text-base flex-shrink-0" [style.color]="bannerConfig.iconColor"></span>
          <p class="text-sm text-text-primary m-0">{{ bannerConfig.text }}</p>
        }
      </div>
      @if (bannerType !== 'kyb-in-review') {
        <button
          class="ml-4 flex-shrink-0 text-sm font-semibold cursor-pointer hover:opacity-90 transition-opacity border rounded-lg px-4 py-1.5"
          [class.text-gray-800]="bannerType === 'kyb-verification'"
          [class.border-white]="bannerType === 'kyb-verification'"
          [class.bg-white]="bannerType === 'kyb-verification'"
          [class.text-text-primary]="bannerType !== 'kyb-verification'"
          [class.border-transparent]="bannerType !== 'kyb-verification'"
          (click)="bannerConfig.buttonAction()"
        >
          {{ bannerConfig.buttonText }}
        </button>
      }
    </div>
  </div>
}
